export const LABEL_DEFAULTS = {
  title1: "MIDWEST TO GENERAL COUNCIL ACCOUNT",
  title2: "FINANCIAL REPORT",
  balance_forward: "balance forward",
  income: "income:",
  income_group: "Juon mottan jonoul",
  total_income: "total income",
  grand_total_income: "grand total income",
  expenditure: "expenditure:",
  grand_total_expense: "grand total expense",
  balance: "balance",
};

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const monthLabel = (ym) => `${MONTHS[Number(ym.slice(5, 7)) - 1]} ${ym.slice(0, 4)}`;
export const periodLabel = (p) => `${monthLabel(p.from)} thru ${monthLabel(p.to)}`;
export const PERIOD_MIN_YEAR = 2026;
export const periodYears = () => {
  const last = Math.max(2050, new Date().getFullYear() + 25);
  return Array.from({ length: last - PERIOD_MIN_YEAR + 1 }, (_, i) => String(PERIOD_MIN_YEAR + i));
};
export const MONTH_NAMES = MONTHS;
export const defaultPeriod = (year) => {
  const y = Math.max(Number(year) || PERIOD_MIN_YEAR, PERIOD_MIN_YEAR);
  return { from: `${y}-01`, to: `${y}-12` };
};
export const periodKey = (p) => `${p.from}_${p.to}`;
export const periodDates = (p) => {
  const [y, m] = p.to.split("-").map(Number);
  return { start: `${p.from}-01`, end: `${p.to}-${String(new Date(y, m, 0).getDate()).padStart(2, "0")}` };
};

export const n2 = (v) => Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const usd = (v) => `$ ${n2(v)}`;
const sum = (list) => list.reduce((a, r) => a + Number(r.amount || 0), 0);

export function gcModel({ cfg, figures, tithes, donations, expenses, toggles }) {
  const L = { ...LABEL_DEFAULTS, ...(cfg.labels || {}) };
  const rows = [];
  const push = (style, num, label, c1 = null, c2 = null, c3 = null) => rows.push({ style, num, label, c1, c2, c3 });
  const income = cfg.income_lines.map((l) => [l.label,
    l.source === "tithe_destination" ? sum(tithes.filter((t) => t.destination === l.ref))
      : l.source === "tithe_type" ? sum(tithes.filter((t) => t.giver_type === l.ref))
      : l.source === "donation_category" ? sum(donations.filter((d) => d.category === l.ref))
        : Number(figures?.manual?.[l.id] || 0), l.group_id]);
  const groups = cfg.income_groups?.length ? cfg.income_groups : [{ id: "_default", name: L.income_group }];
  const gid = (g) => (groups.some((x) => x.id === g) ? g : groups[0].id);
  const ti = income.reduce((a, r) => a + r[1], 0);
  const bf = Number(figures?.balance_forward || 0);
  const gti = bf + ti;
  const subs = cfg.expense_sections.map((s) => s.items.map((i) => [i.name, sum(expenses.filter((e) => e.item_id === i.id))]));
  const gte = subs.flat().reduce((a, r) => a + r[1], 0);
  if (toggles.income !== false) {
    push("head", "I", L.income);
    push("bfrow", "", L.balance_forward, null, null, bf);
    groups.forEach((g, i) => {
      push("group", "", `${i + 1}. ${g.name}`);
      income.filter((r) => gid(r[2]) === g.id).forEach(([l, v]) => push("item", "", l, v));
    });
    push("subtotal", "", L.total_income, null, ti);
    push("grand", "", L.grand_total_income, null, null, gti);
  }
  if (toggles.expenditures !== false) {
    push("head", "II", L.expenditure);
    cfg.expense_sections.forEach((s, i) => {
      push("group", "", `${i + 1}. ${s.name}`);
      subs[i].forEach(([l, v]) => push("item", "", l, v));
      push("subtotal", "", s.subtotal_label || "Total Expenses", null, subs[i].reduce((a, r) => a + r[1], 0));
    });
    push("blank", "", "");
    push("grand", "", L.grand_total_expense, null, null, gte);
  }
  if (toggles.balance !== false) push("balance", "III", L.balance, null, null, gti - gte);
  return { L, rows, gti, gte };
}

const DOLLAR = new Set(["balance"]);

export function gcSection(model, period, label) {
  const { L, rows } = model;
  return {
    title: `${L.title1} - ${L.title2} - ${label || periodLabel(period)}`,
    head: ["", "", "", "", ""],
    body: rows.map((r) => [r.num, r.label, r.c1, r.c2, r.c3]),
    rowStyles: rows.map((r) => r.style),
    rightCols: [2, 3, 4],
    fmt: (v, i, ri) => (v == null || v === "" || i < 2 ? v ?? "" : (i === 4 && (DOLLAR.has(rows[ri].style) || rows[ri].label === L.grand_total_income) ? usd(v) : n2(v))),
  };
}
